import React from 'react';
import { CtaButton } from './CtaButton';
import { CHECKOUT_URL } from '../data/landing';
export function ManifestoSection() {
  return <section className="border-y border-line bg-night" data-id="element-115" data-mp="5858ghhbvvsj">
      <div className="mx-auto max-w-4xl px-5 py-10 text-center md:px-6 md:py-16 lg:py-20" data-id="element-116" data-mp="a66rj2er7v40">
        <h2 className="font-display text-xl leading-tight text-cream md:text-4xl md:leading-tight" data-id="element-117" data-mp="ex6ryhn30vb9">
          No se trata de saberlo todo.
          <span className="mt-2 block text-gold" data-id="element-118" data-mp="iy8tx68dvlgx">
            Se trata de aprender a mirar de otra manera.
          </span>
        </h2>

        <div className="mx-auto mt-5 max-w-2xl space-y-3 text-sm leading-relaxed text-muted md:mt-8 md:text-lg" data-id="element-119" data-mp="nzy4ylvlvz50">
          <p className="font-serif text-lg text-cream md:text-2xl" data-id="element-120" data-mp="xw155m6wdnpb">
            A veces, una nueva perspectiva comienza con una pregunta.
          </p>
          <p data-id="element-121" data-mp="2uq5pk408vfgy">
            Una creencia que decides examinar. Un símbolo cuyo significado te
            despierta curiosidad. Una conexión entre ideas que antes parecían
            separadas.
          </p>
          <p data-id="element-122" data-mp="2n7o3s2mzs3a8">
            EL LIBRO DEL DESPERTAR es una invitación a detenerte, observar y
            explorar con mayor profundidad los temas que influyen en tu manera
            de comprender el mundo.
          </p>
          <p className="text-cream/90" data-id="element-123" data-mp="2de7aczqroq73">
            No necesitas tener todas las respuestas. Solo necesitas curiosidad y
            disposición para seguir explorando.
          </p>
        </div>

        <div className="mt-6 md:mt-8" data-id="element-124" data-mp="362v1vd240bt3">
          <CtaButton href={CHECKOUT_URL} data-id="element-125" data-mp="315uu8xpm30zv">Empieza tu recorrido hoy</CtaButton>
        </div>
      </div>
    </section>;
}